
<template>
<div class="flex tb_list"  @click="goDetail(item)">
    <div class="nr flex"  >
        <i class="iconfont icon-a-46_zhibo_sp" style="color:#24B291" v-if="item.TI_Type == 8 && item.ItemType == 3"></i>
        <i class="iconfont icon-a-47_zhibo_yp" style="color:#24B291" v-if="item.TI_Type == 8 && item.ItemType == 2"></i>
        <i class="iconfont icon-a-49_kaoshi" style="color:#5896E7" v-if="item.TI_Type == 7"></i>
        <i class="iconfont icon-a-48_kecheng" style="color:#5896E7" v-if="item.TI_Type == 1"></i>
        <img :src="getImage(item.ItemType)" v-if="item.TI_Type == 2" class="img"/>
        <span>{{ item.TI_Name }}</span>
    </div>
    <div class="ls f14">--</div>
    <div class="zt f14">{{item.TS_Result=='100'?'已完成':'待完成'}}</div>
    <div class="jd f14"><el-progress :percentage="item.TS_Result" :stroke-width="strokeWidth" :color="item.TS_Result=='100'?customColor2:customColor1"></el-progress> </div> 
     <AudioTip :isTip="isTip" @hideMe="tip"/>
</div>
</template>
<script>
import { addReadStatus  } from '@/api/api'
import Cookies from "js-cookie";
 import AudioTip from '@/components/AudioTip.vue';
export default {
  props:{        
    item:''  ,
    state:''  ,
    taskId:''     
  },
  components: { AudioTip },    
  data() {     
    return {
      isTip: false, //音频直播弹窗
      customColor1: '#24B291',
      customColor2: '#4B9AFB',
      strokeWidth:8,
      images: [
				require('@/assets/images/Know/pdf.png'),//0
        require('@/assets/images/Know/pdf.png'),//1
        require('@/assets/images/Know/docx.png'),//2
        require('@/assets/images/Know/xlsx.png'),//3
        require('@/assets/images/Know/ppt.png'),//4
        require('@/assets/images/Know/tupian.png'),//5
        require('@/assets/images/Know/shipin.png'),//6
        require('@/assets/images/Know/yinpin.png'),//7
        require('@/assets/images/Know/txt.png')//8
			]
    }
  },
  methods: {     
    tip(){
      this.isTip = false;
    },
	  getImage(ItemType) {		
			return this.images[ItemType];			
		},
  	goDetail(item) {//state：0未开始，1进行中，2已完成，3已逾期   TI_Type： 1 课程 2 文档 7考试 8直播     TI_ItemID:子任务ID    TI_ID：任务ID
    console.log(item)
   
		  console.log(this.state)      
    	var that = this;
			if (that.state == '1'||that.state == '2') {
			console.log(this.item.TI_Type)
				if (this.item.TI_Type == 1) {//课程
        console.log(this.item)
					 this.$router.push({ path: this.redirect || "/home/play?liId=" + this.item.TI_ItemID +'&taskId='+this.taskId+'&taskTI_ID='+this.item.TI_ID+'&courseId='+this.item.TI_ItemID})
				} else if (this.item.TI_Type == 7) {//考试
					if (this.item.TS_Result == 100) {//考试完成结果页
          this.$router.push({ path: this.redirect || "/Exam/result?liId=" + this.item.TI_ItemID +'&taskId='+this.taskId+'&taskTI_ID='+this.item.TI_ID})
					
					} else {//去考试
            this.$router.push({ path: this.redirect || "/Exam?liId=" + this.item.TI_ItemID +'&taskId='+this.taskId+'&taskTI_ID='+this.item.TI_ID})
						// var itemUrl = HTTP_HTML_URL + '/yunxue_backstage/static/wap/exam/index.html';
						// // var dataUrl = '?exId=' + this.item.TI_ItemID + '&tiId=' + this.item.TI_ID + '&memberId=' + this.userData.memberId + '&coId=' + this.userData.COID;
						// uni.navigateTo({
						// 	url: '/pages/subpage/document/file/webview?title=' + that.item.TI_Name + '&url=' + itemUrl + '&exId=' + this.item.TI_ItemID + '&tiId=' + this.item.TI_ID,
						// 	fail(err) {
						// 		console.log(JSON.stringify(err));
						// 	}
						// });
					}
				} else if (this.item.TI_Type == 8) {//直播				
					if (this.item.ItemType == 2) {//音频直播
            this.isTip = true;					
					} else {//视频直播
						that.taskState();
            this.$router.push({ path: this.redirect || "/Live?liId=" + this.item.TI_ItemID +'&taskId='+this.taskId+'&taskTI_ID='+this.item.TI_ID})
					}
				} else { //文档           
				    //Cookies.set("documentName",this.item.TI_Name);  
             let { href } = this.$router.resolve({ path: this.redirect || "/Knowledge/view?fiId=" + item.TI_ItemID +'&fiUrl='+item.ItemUrl +'&fiFiletype='+item.ItemType})
             window.open(href, '_blank')      
            // this.$router.push({ path: this.redirect || "/Knowledge/view?fiId=" + this.item.TI_ItemID +'&fiUrl='+this.item.ItemUrl +'&fiFiletype='+this.item.ItemType+'&taskId='+this.taskId+'&taskTI_ID='+this.item.TI_ID})
				}
			} else {
				var ttt = '';
				if (that.state == 0) {
					ttt = '任务未开始';
				} else if (that.state == 3) {
					ttt = '任务已逾期';
				}
				if (ttt) {
		     	 this.$message({
              message: ttt,
              type: 'warning'
            });
				}
			}
		},
    taskState(){        
        var that = this   
        var data = {
            "taskId":this.taskId,
            "memberId": Cookies.get('qslmemberId'),
            "id": this.item.TI_ItemID,
            "readType": 1               
        } 
        console.log(data)
        addReadStatus(data)
        .then(res => {            
            console.log('addReadStatus 6 ready')        
        })
        .catch(err => {});
    }
  }
}
</script>
<style>
.tb_list{
  padding:24px;
  margin:0 24px;
  border-bottom:1px solid #ddd;
  cursor: pointer;
}
.tb_list:hover
  {
    box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.15); 
    border:0
  }
.tb_list .ls,.tb_list .zt{
    color:#999
  }
.tb_list:hover .zt,.tb_list:hover .nr{
    color:#4B9AFB
}
</style>


// WEBPACK FOOTER //
// src/views/Task/components/DetailItem.vue